import React from 'react'
import styled from '@emotion/styled'
import { number } from 'prop-types'
import { useTheme } from 'emotion-theming'

// Import Components
import { Arrow } from '../svgs/Arrow'
import { Plus } from '../svgs/Plus'

// Styled Components via Emotion
export const PlusArrowBlockWrapper = styled.div`
	align-items: center;
	background: ${({ theme }) => theme.hubTemplate.hoverPlusArrowColor};
	bottom: 0;
	display: flex;
	height: ${({ blockHeight }) => blockHeight}px;
	margin-left: auto;
	position: absolute;
	right: 0;
	width: ${({ blockWidth }) => blockWidth}px;
	z-index: 1;
`
export const PlusWrapper = styled.div`
	display: block;
	height: ${({ height }) => `${height}px`};
	margin: auto;

	@media (pointer: none), (pointer: coarse) {
		display: none;
	}
`
export const HoverPlusArrowWrapper = styled.div`
	display: none;
	height: ${({ height }) => `${height}px`};
	transform: rotate(270deg);
	margin: auto;

	@media (pointer: none), (pointer: coarse) {
		display: block;
	}
`

HoverPlusArrow.propTypes = {
	arrowHeight: number,
	arrowWidth: number,
	blockHeight: number,
	blockWidth: number,
	plusHeight: number,
	plusWidth: number,
}
/**
 * This component is mainly used for Card Links
 * Based on actions you can target the plus and arrow signs to change (ex: on hover states)
 *
 * @param {*} props.arrowHeight :: dimensions of the arrow height
 * @param {*} props.arrowWidth :: dimensions of the arrow width
 * @param {*} props.blockHeight :: dimensions of the block height
 * @param {*} props.blockWidth :: dimensions of the block width
 * @param {*} props.plusHeight :: dimensions of the plus height
 * @param {*} props.plusWidth :: dimensions of the plus width
 *
 */
const arrowDimensions = { height: 25, width: 20 }
const blockDimensions = 50
const plusDimensions = { height: 20, width: 20 }
export function HoverPlusArrow({
	arrowHeight = arrowDimensions.height,
	arrowWidth = arrowDimensions.width,
	blockHeight = blockDimensions,
	blockWidth = blockDimensions,
	plusHeight = plusDimensions.height,
	plusWidth = plusDimensions.width,
}) {
	const {
		colors: { white },
	} = useTheme()
	return (
		<PlusArrowBlockWrapper blockHeight={blockHeight} blockWidth={blockWidth}>
			<PlusWrapper className="plusWrapper" height={plusHeight}>
				<Plus color={white} height={plusHeight} width={plusWidth} />
			</PlusWrapper>
			<HoverPlusArrowWrapper className="arrowWrapper" height={arrowHeight}>
				<Arrow height={arrowHeight} width={arrowWidth} />
			</HoverPlusArrowWrapper>
		</PlusArrowBlockWrapper>
	)
}
